module.exports = __webpack_public_path__ + "img/11.199be3fb.gif";